class LoginBtn extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        activeClass: 'is-active',
        closingClass: 'is-closing'
      };
  
      this.querySelectorAll('[data-btn-toggle]').forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
  
    onButtonClick(event) {
      event.preventDefault();  
      this.open();
    }
  
    open() {
        const data_popup = this.getAttribute('data-popup');
        const popup = document.getElementById(data_popup);
        popup.querySelector('.promo-popup').classList.add(this.classes.activeClass)
    }
  }
  customElements.define('login-btn', LoginBtn);
  
class PromoPopup extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        bodyClass: 'promo-popup--open',
        activeClass: 'is-active',
        closingClass: 'is-closing',
        showImage: 'show-image'
      };
  
      this.popup = this.querySelector('.promo-popup');
  
      this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
  
    connectedCallback() {
      if (Shopify.designMode) {
        this.onShopifySectionLoad = this.onSectionLoad.bind(this);
        this.onShopifySectionSelect = this.onSectionSelect.bind(this);
        this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
        document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }
    disconnectedCallback() {
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
  
        document.body.classList.remove(this.classes.bodyClass);
      }
    }
    onSectionLoad(event) {
      filterShopifyEvent(event, this, () => this.open.bind(this));
    }
    onSectionSelect(event) {
      filterShopifyEvent(event, this, this.open.bind(this));
    }
    onSectionDeselect(event) {
      filterShopifyEvent(event, this, this.close.bind(this));
    }
  
    init() {
      if (Shopify && Shopify.designMode) {
        return;
      }
  
      setTimeout(function() {
        this.open();
      }.bind(this), parseInt(this.dataset.delay) * 1000);
    }
  
    onButtonClick(event) {
      event.preventDefault();
      this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
    }
  
    open() {
      document.body.classList.remove(this.classes.bodyClass);
      this.popup.classList.add(this.classes.activeClass);
      setTimeout(() => {
        this.popup.classList.add(this.classes.showImage);
      }, 600);
  
      if (this.popup.dataset.position === 'center') {
        setScrollbarWidth();
        document.body.classList.add(this.classes.bodyClass);
      }
    }
  
    close() {
      this.popup.classList.add(this.classes.closingClass);
  
      setTimeout(() => {
        this.popup.classList.remove(this.classes.activeClass);
        this.popup.classList.remove(this.classes.closingClass);
        this.popup.classList.remove(this.classes.showImage);
  
        if (this.popup.dataset.position === 'center') {
          document.body.classList.remove(this.classes.bodyClass);
        }
      }, 500);
  
  
    }
  }
  customElements.define('promo-popup', PromoPopup);
  